import { render, staticRenderFns } from "./OResetPassSet.vue?vue&type=template&id=9653a624&scoped=true&"
import script from "./OResetPassSet.vue?vue&type=script&lang=ts&"
export * from "./OResetPassSet.vue?vue&type=script&lang=ts&"
import style0 from "./OResetPassSet.vue?vue&type=style&index=0&id=9653a624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9653a624",
  null
  
)

export default component.exports